import React from 'react'

export const ImageGrid = () => {
    return <></>
}
